<template>
  <div class="orderGoods">
    <!-- <div class="total">共{{ cartInfo.length }}件商品</div> -->
    <div class="total">海礼网（北京）智能技术有限公司</div>
    <div class="goodWrapper">
      <div class="item acea-row row-between-wrapper" v-for="cart in cartInfo" :key="cart.id" @click="handleGoProductInfo(cart)">
        <div class="pictrue">
          <img v-lazy="cart.productInfo.image" alt="img" class="image" />
        </div>
        <div class="text">
          <div class="acea-row row-between-wrapper">
            <div class="name line1">{{ cart.productInfo.store_name }}</div>
            <div class="num">x {{ cart.cart_num }}</div>
          </div>
          <div class="attr line1" v-if="cart.productInfo.attrInfo">
            {{ cart.productInfo.attrInfo.suk }}
          </div>
          <div class="money font-color-red">￥{{ cart.productInfo.attrInfo ? cart.productInfo.attrInfo.price : cart.productInfo.price }}</div>
          <div class="evaluate" v-if="evaluate === 3" @click="$router.push({ path: '/goods_evaluate/' + cart.unique })">
            评价
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { goShopDetail } from "@libs/order";
export default {
  name: "OrderGoods",
  props: {
    evaluate: Number,
    cartInfo: {
      type: Array,
      default: () => [],
    },
  },
  data: function() {
    return {};
  },
  mounted: function() {},
  methods: {
    handleGoProductInfo(item) {
      console.log(item);
      goShopDetail(item).then(() => {
        this.$router.push({ path: "/detail/" + item.product_id });
      });
    },
  },
};
</script>
